import {
  DELETE_NEWS_FAILURE,
  DELETE_NEWS_REQUEST,
  DELETE_NEWS_SUCCESS,
  FETCH_NEWS_COMPLETE_FAILURE,
  FETCH_NEWS_COMPLETE_REQUEST,
  FETCH_NEWS_COMPLETE_SUCCESS,
  FETCH_NEWS_FAILURE,
  FETCH_NEWS_REQUEST,
  FETCH_NEWS_SUCCESS,
  FETCH_NEWSS_FAILURE,
  FETCH_NEWSS_REQUEST,
  FETCH_NEWSS_SUCCESS,
  SAVE_NEWS_FAILURE,
  SAVE_NEWS_REQUEST,
  SAVE_NEWS_SUCCESS,
} from '../../reducers/types';
import {
  deleteNewssService,
  getNewsByIdService,
  getNewsCompleteByIdService,
  getNewssService,
  saveNewsService,
} from '../../services/appCmsServices/NewsService';
import { newsPaginationParams } from '../../pages/appCms/news/Constants';

export const getNewssAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_NEWSS_REQUEST,
      });
      const response = await dispatch(getNewssService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_NEWSS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_NEWSS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_NEWSS_FAILURE,
      });
    }
  };
};

export const saveNewsAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_NEWS_REQUEST,
      });
      const response = await dispatch(saveNewsService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_NEWS_SUCCESS,
          payload: response.data,
        });
        dispatch(getNewssAction({ ...newsPaginationParams }));
      } else {
        dispatch({
          type: SAVE_NEWS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_NEWS_FAILURE,
      });
    }
  };
};

export const deleteNewssAction = array => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETE_NEWS_REQUEST,
      });
      const response = await dispatch(deleteNewssService(array));
      if (response.status === 200) {
        dispatch({
          type: DELETE_NEWS_SUCCESS,
        });

        dispatch(getNewssAction({ ...newsPaginationParams }));
      } else {
        dispatch({
          type: DELETE_NEWS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: DELETE_NEWS_FAILURE,
      });
    }
  };
};

export const getNewsByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_NEWS_REQUEST,
      });
      const response = await dispatch(getNewsByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_NEWS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_NEWS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_NEWS_FAILURE,
      });
    }
  };
};

export const getNewsCompleteByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_NEWS_COMPLETE_REQUEST,
      });
      const response = await dispatch(getNewsCompleteByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_NEWS_COMPLETE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_NEWS_COMPLETE_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_NEWS_COMPLETE_FAILURE,
      });
    }
  };
};
